module.exports = class Gate {
	constructor (isOpen) {
		this.isOpen = isOpen === true
		this.cbs = []
	}

	open () {
		this.isOpen = true
		let newcbs = []
		this.cbs.forEach(cb => {
			if (this.isOpen) cb()
			else newcbs.push(cb)
		})
		this.cbs = newcbs
	}

	close () {
		this.isOpen = false
	}

	entry (cb, lock) {
		if (this.isOpen) {
			if (lock) this.isOpen = false
			cb && cb()
			return Promise.resolve()
		}
		return new Promise(resolve => {
			this.cbs.push(() => {
				if (lock) this.isOpen = false
				cb && cb()
				resolve()
			})
		})
	}
}
